import Vue from 'vue';
import confirmV2 from '../components/ui/confirm-v2/index';

Vue.use(confirmV2);
